import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import skillookAdmin from 'apis/skillookAdmin';

// Get Matching Skill Percentage Request

export const getMatchingPercentageRequest = createAsyncThunk(
  'getPercentageData',
  async () => {
    const response = await skillookAdmin.get(
      'admin/users/skills/getPercentageNumber'
    );
    return response.data.data;
  }
);

// Update Matching Skill Percentage Request

export const updateMatchingPercentageRequest = createAsyncThunk(
  'updatePercentageData',
  async body => {
    await skillookAdmin.post('admin/users/skills/changeMatchPercentage', body);
    return body.percentageNumber;
  }
);

// Then, handle actions in your reducers:
const matchingPercentageListSlice = createSlice({
  name: 'allMatchingPercentageList',
  initialState: { id: '', percentage: '' },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [getMatchingPercentageRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        id: action.payload._id,
        percentage: action.payload.percentageNumber,
      };
    },
    [updateMatchingPercentageRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        percentage: action.payload,
      };
    },
  },
});

export const { emptyAllList } = matchingPercentageListSlice.actions;
export default matchingPercentageListSlice.reducer;
